module.exports = __webpack_public_path__ + "static/img/图层45.5c5a25b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层45.png
// module id = Po8f
// module chunks = 0